import React, { ReactNode } from "react";

interface SettingsSectionProps {
  title: string;
  children: ReactNode;
}

/**
 * A labelled group of rows, drawn as a block of surface with no border and no
 * rules between rows.
 *
 * The border and the hairlines were there for two line rows, where they stop
 * one block running into the next. With one line rows the heading and the gap
 * already delimit the group, so all three borders per group were outlining
 * something that was not in doubt. The fill stays: on white it barely
 * registers, but in dark mode it is the step of contrast that keeps the dialog
 * from reading flat.
 */
export default function SettingsSection(props: SettingsSectionProps) {
  const rows = React.Children.toArray(props.children).filter(Boolean);

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-[8px]">
      <div className="text-[10.5px] font-semibold uppercase tracking-[0.08em] text-creator-text-soft">
        {props.title}
      </div>
      <div className="rounded-[8px] bg-creator-primary-background overflow-hidden py-[2px]">
        {rows}
      </div>
    </div>
  );
}
